import React from "react";
import Header from "./Header";
import "../css/sce.css";
import Footer from "./Footer";
function sce() {
  return (
    <div>
      {" "}
      <Header></Header>
      <div className="section0">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4>SEO Code of Ethics</h4>
              <p>An SEO agency you can trust.</p>
              <a href="/#" className="btn btn-outline-primary">
                GET MY FREE PROPOSAL{" "}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="parg">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <p>
                At Thrive Internet Marketing Agency, we commit ourselves to
                honesty and personal accountability in our work. As a provider
                of Internet marketing and Search Engine Optimization (SEO)
                services to our clients, we constantly strive to achieve higher
                rankings, improved traffic and conversions, and positive return
                on investment for our clients’ websites while adhering to the
                following Code of Ethics:
              </p>
              <hr />
              <p>
                <b>1: We will always work to</b> <br /> increase or retain the
                rankings, and increase conversions and return on investment for
                our clients' site to the best of our ability. We will continue
                stay ahead of the curve, keeping pace with the evolution of
                search engine algorithms and changing website technologies.
                <br />
                <br />
                <b>2: We will treat all clients fairly and without bias.</b>
                <br />
                When we provide services for clients in related spaces or
                industries, we will do so fairly, in good faith and without
                bias. We will be diligent in ensuring we are distributing our
                clients’ campaign efforts fairly. When warranted, and possibly
                for a fee, we may assign the accounts being managed by separate
                SEO account managers and SEO specialists.
                <br />
                <br />
                <b>3: We will not set unreasonable client expectations.</b>{" "}
                <br />
                We will set realistic expectations and goals for our services
                and will not make unreasonable promises. We will express honesty
                in discussing the types of results that can be realistically
                expected and those that cannot.
                <br />
                <br />
                <b>
                  4: We will maintain complete confidentiality and protect the
                  anonymity of our clients.
                </b>{" "}
                <br />
                We will not divulge information about any client’s business or
                discuss our SEO work or progress on their site, including any
                lead information, proprietary or intellectual property without
                prior written consent from the client. We will also ensure that
                all Thrive employees and contractors have agreed to written
                agreements of non-disclosure ensuring the confidentiality of all
                client information.
                <br />
                <br />
                <b>
                  5: We will not engage in any activities that intentionally
                  cause harm to a client's brand or reputation.
                </b>{" "}
                <br />
                We will work to ensure that the processes we use adhere to
                search engine and directory guidelines and will never knowingly
                use tactics or techniques that are known to get sites penalized
                or removed from the search engine indexes or directories.
                <br />
                <br />
                <b>
                  6: We reserve the right to not work with businesses that could
                  be considered controversial or political.
                </b>{" "}
                <br />
                This includes political campaigns, political news networks,
                gambling, drugs, pornography or sexually explicit businesses,
                and products or services seen as opportunistic to national
                emergencies. This list is not exhaustive and we reserve the
                right by our sole discretion to determine if a client is a good
                fit for our agency.
                <br />
                <br />
                <b>
                  7: We will not intentionally violate published rules of search
                  engines.
                </b>{" "}
                <br />
                We will constantly work to ensure we are up-to-date on the rules
                and guidelines of the search engines. As changes to the rules
                and guidelines take place, we will act as necessary to ensure
                our client's site remains in compliance so as to avoid any
                potential violations.
                <br />
                <br />
                <b>
                  8: We will not intentionally violate any governmental laws.
                </b>{" "}
                <br />
                We will do our due diligence to ensure we are not in violation
                of any copyright laws or infringing on trademarks. We ensure our
                practices are in line with all applicable local, state and
                international always and regulations of conduct for business and
                Internet operations.
                <br />
                <br />
                <b>
                  9: We will not falsely represent others' work as our own.
                </b>{" "}
                <br />
                We will seek to provide original content and designs for all
                clients in order to avoid any potential plagiarism issues. Any
                content we may utilize which is produced for us by a third party
                will be used with their expressed consent of its usage.
                <br />
                <br />
                <b>
                  10: We will not intentionally deceive or mislead consumers or
                  search engine crawlers.
                </b>{" "}
                <br />
                We will work to ensure we do not misrepresent the client or
                intentionally display inaccurate information on the client’s
                behalf either within search engine results listings or
                advertisements or within the content on the client’s website.
                <br />
                <br />
                <b>
                  11: We will not misrepresent our services or ourselves.
                </b>{" "}
                <br />
                We will be truthful in relaying all details of our Search Engine
                Optimization services, methods, skills, certifications,
                training, performance history, resources and timetables, and
                never intentionally mislead our clients on the details of such.
                <br />
                <br />
                <b>
                  12: We will provide all clients with adequate dispute
                  resolution procedures.
                </b>{" "}
                <br />
                This includes the publishing of address and phone number
                information for our Customer Support team so it is easily found
                on our website. We will also make available on request the
                information on the jurisdiction under which any legal disputes
                will be settled.
              </p>
              <br />
              <br />
              <hr />
              <p>
                As Search Engine Optimization professionals we hereby vow to
                abide by the aforementioned SEO Code of Ethics and agree to
                conduct our business with full integrity to ensure the continued
                success of not only our company but also the success and
                prosperity of our clients’ businesses as well. <br />
                <b>~ Matt Bowman, President</b> <br />
                [On behalf of all Thrive employees]
              </p>
              <img
                src="https://thriveagency.com/files/awardimage2022-1-1.jpeg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default sce;
